import { useEffect, useState } from 'react';
import axios from 'axios';
import { getClient, updateClientApi } from '@/api/client';

export const useUpdateClient = (clientId: string) => {
  const [defaultValues, setDefaultValues] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const response = await getClient(clientId);
        setDefaultValues(response); // Set fetched client data as default values
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch client data');
        setLoading(false);
      }
    };

    fetchClient();
  }, [clientId]);

  const updateClient = async (updatedData: any) => {
    try {
      const response = await updateClientApi(clientId, updatedData);
      return response;
    } catch (err) {
      throw new Error('Failed to update client');
    }
  };

  return { defaultValues, loading, error, updateClient };
};
